// extracted by mini-css-extract-plugin
module.exports = {"playSquare":"playSquare_playSquare__3ANNh","value":"playSquare_value__2xe9V","question":"playSquare_question__2A_jA","answer":"playSquare_answer__17TS_"};